import React from 'react';
import { DownloadsTab } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/DownloadsPageLayout';
import ProfileContainerLayout from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Profile/ProfileContainerLayout';
import { BEACON_SETTINGS_LABELS } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/settingsPageConfigs';
import UserTeamManagement from 'src/routes/UserAccount/UserTeamManagement/UserTeamManagement';
import { useAppSelector } from 'src/utils/Hooks';
import useNotificationsBadge from 'src/utils/Hooks/useNotificationsBadge';
import AtlasV2DownloadsPageLayout from 'src/components/AtlasV2Components/AtlasV2Settings/AtlasV2DownloadsPageLayout';
import PresentationsContainerLayout from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationsContainerLayout';
import { shouldShowPresentations, showAtlasAlertV1 } from 'src/utils/app';
import { NewSettingsLayoutProps } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/NewSettingsLayout';
import { NotificationBadge } from 'src/components/common/NotificationBadge';
import AtlasV2AlertsPageLayout from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Alerts/atlas/AtlasV2AlertsPageLayout';

export enum ATLAS_SETTINGS_LABELS {
  PROFILE = 'Profile',
  SUMMARY = 'Summary',
  SECURITY = 'Security',
  DOWNLOADS = 'Downloads',
  TEAM = 'Team',
  PRESENTATIONS = 'Presentations',
  ALERTS = 'Alerts'
}

export const useAtlasV2SettingRoutes = (props: NewSettingsLayoutProps) => {
  const { queryParams } = useAppSelector((state) => state.app);
  const { searchParams } = queryParams;

  const shouldShowNotificationBadge = useNotificationsBadge(
    (state) =>
      state.notificationBadges.presentations || state.notificationBadges.export || state.notificationBadges.adjustments
  );
  const showAlert = showAtlasAlertV1();

  const {
    user,
    handleProfileChange,
    onSubmit,
    handlePhoneNumberChange,
    handleNewPasswordChange,
    handlePasswordConfirmationChange,
    profile
  } = props;

  const tabs = [
    {
      label: BEACON_SETTINGS_LABELS.PROFILE,
      route: `/account/profile${searchParams}`,
      index: 0,
      renderComponent: (
        <ProfileContainerLayout
          user={user}
          handleProfileChange={handleProfileChange}
          onSubmit={onSubmit}
          handlePhoneNumberChange={handlePhoneNumberChange}
          handleNewPasswordChange={handleNewPasswordChange}
          handlePasswordConfirmationChange={handlePasswordConfirmationChange}
          profile={profile}
        />
      )
    },
    {
      label: (
        <div>
          {BEACON_SETTINGS_LABELS.DOWNLOADS}
          {shouldShowNotificationBadge && <NotificationBadge />}
        </div>
      ),
      route: `/account/downloads${searchParams}&tab=${DownloadsTab.ExportsDownload}`,
      index: 1,
      renderComponent: <AtlasV2DownloadsPageLayout />
    },
    {
      label: BEACON_SETTINGS_LABELS.TEAM,
      oldBeaconPath: 'account',
      oldBeaconEntity: 'profile',
      route: `/account/team${searchParams}`,
      index: 2,
      renderComponent: <UserTeamManagement />
    },
    ...(shouldShowPresentations()
      ? [
          {
            label: BEACON_SETTINGS_LABELS.PRESENTATIONS,
            route: `/account/presentations/type${searchParams}`,
            index: 3,
            renderComponent: <PresentationsContainerLayout />
          },
          {
            label: BEACON_SETTINGS_LABELS.PRESENTATIONS,
            route: `/account/presentations/selections${searchParams}`,
            index: 3,
            hidden: true
          },
          {
            label: BEACON_SETTINGS_LABELS.PRESENTATIONS,
            route: `/account/presentations/brands${searchParams}`,
            index: 3,
            hidden: true
          },
          {
            label: BEACON_SETTINGS_LABELS.PRESENTATIONS,
            route: `/account/presentations/confirmations${searchParams}`,
            index: 3,
            hidden: true
          }
        ]
      : []),
    ...(showAlert
      ? [
          {
            label: ATLAS_SETTINGS_LABELS.ALERTS,
            route: `/account/alerts${searchParams}`,
            index: 4,
            renderComponent: <AtlasV2AlertsPageLayout />
          },
          {
            label: ATLAS_SETTINGS_LABELS.ALERTS,
            route: `/account/alerts/team${searchParams}`,
            index: 4,
            hidden: true,
            renderComponent: <AtlasV2AlertsPageLayout />
          },
          {
            label: ATLAS_SETTINGS_LABELS.ALERTS,
            route: `/account/alerts/template${searchParams}`,
            index: 4,
            hidden: true,
            renderComponent: <AtlasV2AlertsPageLayout />
          },
          {
            label: ATLAS_SETTINGS_LABELS.ALERTS,
            route: `/account/alerts/create${searchParams}`,
            index: 4,
            hidden: true,
            renderComponent: <AtlasV2AlertsPageLayout />
          },
          {
            label: ATLAS_SETTINGS_LABELS.ALERTS,
            route: `/account/alerts/edit${searchParams}`,
            index: 4,
            hidden: true,
            renderComponent: <AtlasV2AlertsPageLayout />
          }
        ]
      : [])
  ];

  return tabs;
};
